import { FC, ReactNode } from 'react';

import { Breakpoints } from '@rikstv/play-common/src/components/grid/breakpoints';
import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { getImagePackSet } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import { Body, H2, PrimaryButton } from '@rikstv/shared-components';

import { AssetImage } from '../assetImage/AssetImage';

import './PlayerDialog.scss';

interface OwnProps {
  posterUrl?: string;
  heading?: string | JSX.Element;
  description?: string;
  footer?: ReactNode;
}

interface OwnPropsWithoutButton extends OwnProps {
  buttonText?: never;
  linkOrClickHandler?: never;
}

interface OwnPropsWithButton extends OwnProps {
  buttonText: string;
  linkOrClickHandler: string | (() => void);
}

type Props = OwnPropsWithoutButton | OwnPropsWithButton;

export const PlayerDialog: FC<Props> = ({
  posterUrl,
  heading,
  buttonText,
  description,
  linkOrClickHandler,
  footer,
}) => {
  let action;
  if (buttonText) {
    if (typeof linkOrClickHandler === 'string') {
      action = (
        <LinkButton className="player-dialog__action" to={linkOrClickHandler} buttonStyle="primary">
          {buttonText}
        </LinkButton>
      );
    } else {
      action = (
        <PrimaryButton className="player-dialog__action" onClick={linkOrClickHandler}>
          {buttonText}
        </PrimaryButton>
      );
    }
  }

  return (
    <div className="player-dialog">
      {posterUrl && (
        <AssetImage
          imageSet={getImagePackSet({
            url: posterUrl,
            variations: [
              { width: 1500, breakpoint: Breakpoints.XXL },
              { width: 800, breakpoint: Breakpoints.LG },
              { width: 600, breakpoint: Breakpoints.MD },
              { width: 800, breakpoint: Breakpoints.DEFAULT },
            ],
          })}
          alt={''}
          className="player-dialog__background-image"
        />
      )}
      <div className="player-dialog__content">
        {heading && <H2 className="player-dialog__header">{heading}</H2>}
        {description && <Body className="player-dialog__description">{description}</Body>}
        {action}
        {footer}
      </div>
    </div>
  );
};
